import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { Link, LinkProps } from "@chakra-ui/react";

export function CustomLink({ href, isExternal, ...props }: LinkProps) {
  return (
    <Link
      color="brand.500"
      {...(isExternal ? { href } : { as: GatsbyLink, to: href })}
      {...props}
    />
  );
}
